import React from 'react';
import styled from '@emotion/styled';
import { useIntl } from 'react-intl';
import {
  ImageWithCaption,
  Publication,
  Quote,
  YoutubeVideo,
  CallToAction,
  TeaserCampaign,
  CardGrid,
  Faq,
  TeaserNavigation,
  Gallery,
  AnchorTag,
  GenericTeaserModule,
  IFrame,
} from 'ech-components/src/components';
import {
  youtubeVideoService,
  callToActionService,
  factsService,
  faqService,
  navigationTeaserService,
  galleryService,
  anchorTagService,
  customFrontendElementService,
  genericTeaserModuleService,
  navSectionService,
  publicationService,
  highlightModuleService,
  newsletterModuleService,
} from '~/services/index';
import NavSection from '../NavSection';

const StyledInfoTag = styled.div`
  font-size: 9px;
  font-weight: 100;
  color: white;
  background: rgba(0, 0, 0, 0.3);
  padding: 2px 4px;
  letter-spacing: 0.05rem;
`;

const Custom = ({ nodeType, data }: CustomProps) => {
  const intl = useIntl();
  const componentMapping: any = {
    ContentfulImage: ImageWithCaption,
    ContentfulLeadImage: ImageWithCaption,
    ContentfulYoutubeLink: YoutubeVideo,
    ContentfulQuotation: Quote,
    ContentfulAsset: ImageWithCaption,
    ContentfulPublication: Publication,
    ContentfulCallToActionModule: CallToAction,
    ContentfulIFrame: IFrame,
    ContentfulHighlightModule: TeaserCampaign,
    ContentfulFaqModule: Faq,
    ContentfulNavigationTeaserModule: TeaserNavigation,
    ContentfulGalleryModule: Gallery,
    ContentfulAnchorTag: AnchorTag,
    ContentfulAnchorTagNavigationPlaceholder: 'NavSectionModule',
    ContentfulFactsModule: 'FactsModule',
    ContentfulStoryTeaserModule: 'StoryTeaserModule',
    ContentfulToolTeaserModule: 'ToolTeaserModule',
    ContentfulCustomFrontendElement: 'CustomFrontendElement',
    ContentfulGenericTeaserModule: GenericTeaserModule,
    ContentfulModuleNewsletter: 'NewsletterModule',
  };

  let TagName = componentMapping[nodeType];

  if (!TagName) {
    return <StyledInfoTag>unrendered</StyledInfoTag>;
  }

  let serviceData;

  switch (TagName) {
    case YoutubeVideo:
      serviceData = youtubeVideoService(data);
      break;
    case CallToAction:
      serviceData = callToActionService(data);
      break;
    case IFrame:
      serviceData = data.iFrame;
      break;
    case Faq:
      serviceData = faqService(data, intl);
      break;
    case TeaserNavigation:
      serviceData = navigationTeaserService(data);
      break;
    case Gallery:
      serviceData = galleryService(data);
      break;
    case AnchorTag:
      serviceData = anchorTagService(data);
      break;
    case 'FactsModule':
      TagName = CardGrid;
      serviceData = factsService(data, intl);
      break;
    case 'NavSectionModule':
      TagName = NavSection;
      serviceData = navSectionService(data, intl);
      break;
    case 'CustomFrontendElement':
      return customFrontendElementService(data, intl);
    case 'NewsletterModule':
      return newsletterModuleService(data);
    case GenericTeaserModule:
      serviceData = genericTeaserModuleService(data, intl);
      break;
    case TeaserCampaign:
      serviceData = highlightModuleService(data);
      break;
    case Publication: {
      const pubdata = publicationService(data);
      serviceData = pubdata
        ? {
            data: pubdata,
          }
        : null;
      break;
    }
    default:
      serviceData = {
        data: { ...data, lang: intl.locale },
      };
  }

  return serviceData ? <TagName {...serviceData} /> : null;
};

export type CustomProps = {
  /** Contentful node type */
  nodeType: string;
  /** Dataset for custom component */
  data: any;
};

export default Custom;
